module.exports = __webpack_public_path__ + "img/f5651045a9bafd384e0cf4a4e3b5b012.png";